import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { challengesService } from 'src/services/challenges.service'


export const initialtConsumerChallengesFilter = {
  query: '',
}

export const useGetConsumerChallanges = (filter: IFilter) => {
  return useQuery(
    [QUERY_KEYS.CONSUMER_CHALENGES, filter],
    () =>
      challengesService.getConsumerChallenges(
        removeDefaultParams(filter, { ...initialtConsumerChallengesFilter, status: ['all'] }),
      ),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 12 * 60 * 1000,
    },
  )
}
